import { render, staticRenderFns } from "./ClaudeMCPSetup.vue?vue&type=template&id=d17fa0d2&scoped=true"
import script from "./ClaudeMCPSetup.vue?vue&type=script&lang=js"
export * from "./ClaudeMCPSetup.vue?vue&type=script&lang=js"
import style0 from "./ClaudeMCPSetup.vue?vue&type=style&index=0&id=d17fa0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d17fa0d2",
  null
  
)

export default component.exports